import React, { useState, useEffect } from "react";
import ArticuloService from "../../services/articulo.service";
import { useCart } from "react-use-cart";
import {
  calcularPrecioVenta,
  obtenerGananciaEfectiva,
} from "../../utils/precios";
import { esVideo } from "../../utils/media";

import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ImageIcon from "@mui/icons-material/Image";

require("dotenv").config();
const API_URL = process.env.REACT_APP_URL;

const ProductoCard = ({ articulo, onClick, onAddToCart }) => {
  const [image, setImage] = useState(null);
  const [nombreArchivo, setNombreArchivo] = useState(null);
  const [precioFinal, setPrecioFinal] = useState(0);
  const [gananciaPct, setGananciaPct] = useState(0);
  const [loading, setLoading] = useState(true);
  const { items } = useCart();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setImage(null);

    // Verificar que el articulo tenga ID válido
    if (!articulo || !articulo.articulos_id) {
      console.error("[ProductoCard] articulo sin articulos_id:", articulo);
      setLoading(false);
      return;
    }

    console.log(`[ProductoCard] Renderizando articulo ID=${articulo.articulos_id}, codigo=${articulo.codigo}`);

    // 1. Calcular precio con ganancia
    const user = JSON.parse(localStorage.getItem("user"));
    const gananciaGlobal = user?.ganancia || 0;

    const resultado = calcularPrecioVenta(articulo, gananciaGlobal);
    const gananciaEfectiva = obtenerGananciaEfectiva(articulo, gananciaGlobal);

    if (!cancelled) {
      setPrecioFinal(resultado);
      setGananciaPct(gananciaEfectiva);
    }

    // 2. Cargar imagen (igual que ProductoDetalle, que funciona)
    ArticuloService.getFotosArticulo(articulo.articulos_id).then(
      (response) => {
        if (cancelled) return;

        const allFiles = response.data?.files || [];
        console.log(`[Card ${articulo.articulos_id}] Archivos recibidos:`, allFiles);

        // Filtrar archivos válidos (no .DS_Store, no Gris.png)
        const validFiles = allFiles.filter(
          (f) => f && typeof f === "string" && !f.startsWith(".") && f !== "Gris.png"
        );

        console.log(`[Card ${articulo.articulos_id}] Archivos válidos:`, validFiles);

        if (validFiles.length > 0) {
          const imageUrl = API_URL + "/Images/" + articulo.articulos_id + "/" + encodeURIComponent(validFiles[0]);
          console.log(`[Card ${articulo.articulos_id}] URL imagen:`, imageUrl);
          setImage(imageUrl);
          setNombreArchivo(validFiles[0]);
        } else {
          console.log(`[Card ${articulo.articulos_id}] Sin imagen válida`);
          setImage(null);
          setNombreArchivo(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error(`[Card ${articulo.articulos_id}] Error cargando fotos:`, error);
        if (!cancelled) {
        setImage(null);
          setNombreArchivo(null);
          setLoading(false);
        }
      }
    );

    return () => {
      cancelled = true;
    };
  }, [articulo]);

  const cantidadEnCarrito = items.find(
    (item) => item.id === articulo.articulos_id
  );

  const handleAdd = (e) => {
    e.stopPropagation();
    if (onAddToCart) onAddToCart(articulo, precioFinal);
  };

  const handleImageError = () => {
    console.warn(`[Card ${articulo.articulos_id}] Error cargando imagen, mostrando placeholder`);
    setImage(null);
  };

  if (loading) {
    return (
      <div className="tienda-producto-card tienda-card-loading">
        <div className="tienda-card-image-wrapper">
          <div className="tienda-skeleton-image" />
        </div>
        <div className="tienda-card-body">
          <div className="tienda-skeleton-text tienda-skeleton-price" style={{ marginBottom: 8 }} />
          <div className="tienda-skeleton-text tienda-skeleton-title" style={{ marginBottom: 4 }} />
          <div className="tienda-skeleton-text tienda-skeleton-code" style={{ marginBottom: 12, width: "50%" }} />
          <div className="tienda-skeleton-text" style={{ height: 38, borderRadius: 8 }} />
        </div>
      </div>
    );
  }

  return (
    <div className="tienda-producto-card" onClick={() => onClick(articulo)}>
      <div className="tienda-card-image-wrapper">
        {image && esVideo(nombreArchivo) ? (
          <video
            key={`video-${articulo.articulos_id}-${nombreArchivo}`}
            src={image}
            autoPlay
            muted
            loop
            playsInline
            className="tienda-card-video"
            onError={(e) => {
              console.warn(`[Card ${articulo.articulos_id}] Error cargando video:`, e);
              setImage(null);
              setNombreArchivo(null);
            }}
          />
        ) : image ? (
          <img
            src={image}
            alt={articulo.descri}
            className="tienda-card-image"
            loading="lazy"
            onError={handleImageError}
          />
        ) : (
          <div className="tienda-card-noimage">
            <ImageIcon className="tienda-card-noimage-icon" />
          </div>
        )}
        {cantidadEnCarrito && (
          <div className="tienda-card-badge">
            <ShoppingCartIcon className="tienda-card-badge-icon" />
            <span>{cantidadEnCarrito.quantity}</span>
          </div>
        )}
      </div>
      <div className="tienda-card-body">
        <div className="tienda-card-price">
          <span className="tienda-card-price-symbol">$</span>
          <span className="tienda-card-price-amount">
            {articulo.PRE_VTA ? parseFloat(articulo.PRE_VTA).toFixed(2) : "0.00"}
          </span>
        </div>
        <p className="tienda-card-title" title={articulo.descri}>
          {articulo.descri}
        </p>
        <div className="tienda-card-venta">
          <span className="tienda-card-venta-label">Precio de venta:</span>
          <span className="tienda-card-venta-price">${precioFinal.toFixed(2)}</span>
        </div>
        <div className="tienda-card-ganancia">
          <span className="tienda-card-ganancia-label">Ganancia:</span>
          <span className="tienda-card-ganancia-value">{gananciaPct}%</span>
        </div>
        <p className="tienda-card-code">Código: {articulo.codigo}</p>
        {articulo.FORMATO && (
          <p className="tienda-card-code">Formato: {articulo.FORMATO}</p>
        )}
        <button
          className="tienda-card-btn"
          onClick={handleAdd}
          title="Agregar al carrito"
        >
          <AddShoppingCartIcon className="tienda-card-btn-icon" />
          <span>Agregar</span>
        </button>
      </div>
    </div>
  );
};

export default ProductoCard;
